export default {
  price_vendor_management: ['price_vendor_management'],
  price_vendor_add: ['price_vendor_add'],
  price_vendor_edit: ['price_vendor_edit'],
  price_vendor_delete: ['price_vendor_delete'],
  price_vendor_archive: ['price_vendor_archive'],
  price_vendor_restore: ['price_vendor_restore']
}
